export default {
  'operationLog.title': 'Nhật ký thao tác',
  'operationLog.filter.timeRange': 'Thời gian thao tác',
  'operationLog.filter.loginName': 'Tài khoản',
  'operationLog.filter.loginNamePlaceholder': 'Tài khoản đăng nhập',
  'operationLog.filter.menuId': 'Menu',
  'operationLog.filter.menuIdPlaceholder': 'Tìm hoặc chọn menu',
  'operationLog.menuNone': 'Không',
  'operationLog.filter.requestUrl': 'Đường dẫn',
  'operationLog.filter.requestUrlPlaceholder': 'Tìm gần đúng, vd /user/mgmt',
  'operationLog.filter.requestMethod': 'Phương thức',
  'operationLog.filter.rsCode': 'rsCode',
  'operationLog.filter.clientIp': 'IP khách',
  'operationLog.filter.serviceName': 'Dịch vụ',
  'operationLog.filter.traceId': 'TraceId',
  'operationLog.filter.search': 'Tìm kiếm',
  'operationLog.filter.reset': 'Đặt lại',
  'operationLog.col.operationTime': 'Thời gian',
  'operationLog.col.loginName': 'Tài khoản',
  'operationLog.col.systemName': 'Tên',
  'operationLog.superAdmin': 'siêu quản trị viên',
  'operationLog.col.menu': 'Menu',
  'operationLog.col.serviceName': 'Dịch vụ',
  'operationLog.col.requestMethod': 'PT',
  'operationLog.col.requestUrl': 'Đường dẫn',
  'operationLog.col.rsCode': 'rsCode',
  'operationLog.col.rsMessages': 'rsMessages',
  'operationLog.col.clientIp': 'IP',
  'operationLog.col.durationMs': 'Thời gian xử lý(ms)',
  'operationLog.col.traceId': 'TraceId',
  'operationLog.col.detail': 'Chi tiết',
  'operationLog.detail.title': 'Chi tiết nhật ký',
  'operationLog.detail.basic': 'Thông tin cơ bản',
  'operationLog.detail.userAgent': 'User-Agent',
  'operationLog.detail.requestParams': 'Tham số yêu cầu',
  'operationLog.detail.responseSummary': 'Tóm tắt phản hồi',
  'operationLog.detail.exceptionMsg': 'Ngoại lệ',
  'operationLog.fetchError': 'Truy vấn thất bại, vui lòng thử lại',
};
